import React from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";

const RaikoNumberInputOutlined = (
    {
        labelText = "",
        placeHolder = "",
        value,
        setValue,
        onChange,
        className,
        disabled
    }) => {

    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={`
            ${
                css`
                  direction: ltr;
                  text-align: end;


                  input::-webkit-outer-spin-button,
                  input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                  }


                  input[type=number] {
                    -moz-appearance: textfield;
                  }

                `
            } ${
                className
            }`}
            disabled={disabled}
            type={"number"}
            value={value}
            onChange={e => {
                if (onChange)
                    onChange(e)

                if (setValue)
                    setValue(e.target.value)
            }}/>
    )
}
RaikoNumberInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}

export default RaikoNumberInputOutlined